<div id="overlay" *ngIf="isLoading" class="loading-overlay">
  <div class="loading-spinner"><img src="/content/images/loading3.gif" width="80" height="80" alt="Loading..."/></div>
</div>
<div class="row claim-profile step-3">
  <div class="col center" *ngIf="isLoading">
      Checking verification token...
  </div>
  <div class="col center" *ngIf="verifyResultModel.success && !isLoading">
    <h1>Create your <span class="block bold">Rankipedia account</span></h1>
    <p class="mt70 mb40">
      Now that we've confirmed your email address, set your password to complete claiming your Rankipedia profile.
    </p>
    <form [formGroup]="authService.finalizeClaimModel" *ngIf="authService.finalizeClaimModel" name="frmClaimFinalize">
      <div class="password">
        <h3>
          Create your password
          <em>
            (must contain at lease 1 uppercase character, 1 lowercase
            character and 1 number)
          </em>
        </h3>
        <div class="row" formGroupName="passwords">
          <div class="field half form-group">
            <input type="password"
                   id="register-pw"
                   placeholder="Password *"
                   data-lpignore="true"
                   class="form-control inputvalid"
                   formControlName="password"
                   ng-minlength="6" />
            <label for="register-pw">Password *</label>
            <span class="pass-view"></span>
          </div>
          <div class="field half form-group">
            <input type="password"
                   id="register-confirm-pw"
                   placeholder="Confirm Password *"
                   data-lpignore="true"
                   class="form-control inputvalid"
                   formControlName="confirmPassword"
                   ng-minlength="6" />
            <label for="register-confirm-pw">Confirm Password *</label>
            <span class="pass-view"></span>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="!passwordValid()|| !confirmPasswordValid()">
        <div class="form-group error-container" *ngIf="!passwordValid()">
          <small class="error">Password must be at least 6 characters, contain a capital letter, a number and a special character.</small>
        </div>
        <div class="form-group error-container" *ngIf="!confirmPasswordValid()">
          <small class="error">The passwords do not match.</small>
        </div>
      </div>
      <input type="checkbox" id="agree-t-c" formControlName="agree" />
      <label for="agree-t-c">By checking this box, I agree to Rankipedia's <a href="/TermsOfUse" target="_blank">Terms of Use</a> and <a href="/PrivacyPolicy" target="_blank">Privacy Policy</a></label>
      <div class="form-group">
        <br />
        <re-captcha formControlName="recaptcha"
                    (resolved)="reCaptchaResolved($event)"></re-captcha>
      </div>
      <button class="btn primary" [disabled]="!formIsValid()" (click)="completeClaim()">Complete Claim</button>
    </form>
  </div>
  <div class="col center" *ngIf="!verifyResultModel.success && !isLoading">
    <div class="error-container">
      <small class="error">
        {{verifyResultModel.msg}}
      </small>
    </div>
  </div>
</div>
